import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const CancelacionPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Cancelación de linea</PageTitle>
      <View />
    </>
  );
};

export { CancelacionPage };
